import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  invoiceNumber: {
    type: "text", //required
    name: "invoiceNumber", //required
    label: "Invoice Number", //required
    disabled: true,
  },
  invoiceDate: {
    type: "text",
    name: "invoiceDate",
    label: "Invoice Date",
    disabled: true,
  },
  billDtFr: {
    type: "text",
    name: "billDtFr",
    label: "Bill Date From",
    disabled: true,
  },
  billDtTo: {
    type: "text",
    name: "billDtTo",
    label: "Bill Date To",
    disabled: true,
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    disabled: true,
  },
  billingPeriod: { type: "text", name: "billingPeriod", label: "Billing Period", maxLength: 20 },
  paymentTerms: { type: "text", name: "paymentTerms", label: "Payment Terms", maxLength: 20 },
  personName: { type: "text", name: "personName", label: "Person In Charge", maxLength: 100 },
  billCompany: { type: "text", name: "billCompany", label: "Bill Company", maxLength: 100 },
  billAddress1: { type: "text", name: "billAddress1", label: "Bill Address1", maxLength: 200 },
  billAddress2: { type: "text", name: "billAddress2", label: "Bill Address2", maxLength: 200 },
  billPostcode: { type: "text", name: "billPostcode", label: "Bill Postcode", maxLength: 10 },
  billCity: { type: "text", name: "billCity", label: "Bill City", maxLength: 100 },
  billState: { type: "text", name: "billState", label: "Bill State", maxLength: 100 },
  billCountry: { type: "text", name: "billCountry", label: "Bill Country", maxLength: 100 },
  billPhone: { type: "text", name: "billPhone", label: "Bill Tel No", maxLength: 20 },
};

const {
  invoiceNumber,
  invoiceDate,
  billDtFr,
  billDtTo,
  customerCode,
  billingPeriod,
  paymentTerms,
  personName,
  billCompany,
  billAddress1,
  billAddress2,
  billPostcode,
  billCity,
  billState,
  billCountry,
  billPhone,
} = formField;

export const headerRender = [
  [invoiceNumber, invoiceDate, billDtFr, billDtTo],
  [customerCode, billingPeriod, paymentTerms, personName],
  [billCompany, billAddress1, billAddress2, billPostcode],
  [billCity, billState, billCountry, billPhone],
];
export const headerValues = getInitialValues(formField);

export const headerValidation = Yup.object().shape({
  [billingPeriod.name]: Yup.string().nullable().max(billingPeriod.maxLength),
  [paymentTerms.name]: Yup.string().nullable().max(paymentTerms.maxLength),
  [personName.name]: Yup.string().nullable().max(personName.maxLength),
  [billCompany.name]: Yup.string().nullable().max(billCompany.maxLength),
  [billAddress1.name]: Yup.string().nullable().max(billAddress1.maxLength),
  [billAddress2.name]: Yup.string().nullable().max(billAddress2.maxLength),
  [billPostcode.name]: Yup.string().nullable().max(billPostcode.maxLength),
  [billState.name]: Yup.string().nullable().max(billState.maxLength),
  [billCity.name]: Yup.string().nullable().max(billCity.maxLength),
  [billCountry.name]: Yup.string().nullable().max(billCountry.maxLength),
  [billPhone.name]: Yup.string().nullable().max(billPhone.maxLength),
});
